import React, { FC } from 'react';
import { Text, View, TouchableOpacity } from 'react-native';
import i18n from 'i18n-js';

import TouchableElement from '@components/common/touchableElement';
import { Element, notchBottom, scale } from '@components/frame';
import { font } from '@styles/fonts';
import { modalBg } from '@v2/pages/common/constants/base.constants';
import { ColorFunction } from '@styles/colors/types';

interface DiscardChangesPopupProps {
  showDiscardChangesPopup: boolean;
  triggerDiscardChangesPopup: () => void;
  cancelCrop: () => void;
  C: ColorFunction;
}

const DiscardChangesPopup: FC<DiscardChangesPopupProps> = ({ showDiscardChangesPopup, triggerDiscardChangesPopup, cancelCrop, C }) => {
  if (!showDiscardChangesPopup) return null;

  return (
    <Element
      {...{
        config: {
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '100%',
          backgroundColor: C('Overlay/Light/Dim strong'),
          zIndex: 1000001,
        },
      }}
    >
      <TouchableOpacity
        style={{
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
        }}
        activeOpacity={1}
        onPress={triggerDiscardChangesPopup}
      >
        <Element
          {...{
            config: {
              position: {
                bottom: 0,
              },
              width: 344,
              paddingBottom: 8 + notchBottom,
            },
          }}
        >
          <View style={{ marginBottom: scale(8) }}>
            <TouchableElement onPress={cancelCrop}>
              {({ boxStyle, pressHoverColor }) => (
                <View
                  style={[
                    boxStyle,
                    {
                      width: '100%',
                      backgroundColor: C(pressHoverColor(modalBg)),
                      borderRadius: scale(13),
                      height: scale(60),
                      justifyContent: 'center',
                      alignItems: 'center',
                    },
                  ]}
                >
                  <Text style={[font.Body, { color: C('Label/Light/Error') }]}>{i18n.t('Discard Changes')}</Text>
                </View>
              )}
            </TouchableElement>
          </View>
          <View>
            <TouchableElement onPress={triggerDiscardChangesPopup}>
              {({ boxStyle, pressHoverColor }) => (
                <View
                  style={[
                    boxStyle,
                    {
                      width: '100%',
                      backgroundColor: C(pressHoverColor('Background/Light/System')),
                      borderRadius: scale(13),
                      height: scale(60),
                      justifyContent: 'center',
                      alignItems: 'center',
                    },
                  ]}
                >
                  <Text style={[font.Body, { color: C('Selected/Light/List item') }]}>{i18n.t('Cancel')}</Text>
                </View>
              )}
            </TouchableElement>
          </View>
        </Element>
      </TouchableOpacity>
    </Element>
  );
};

export default DiscardChangesPopup;
